export default __webpack_public_path__ + "static/media/white-labelled-solution.20cd6cad.svg";